import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

import styles from './Dispositivos.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t) => [
  {
    width: '16%',
    title: t('tables.devices.columns.name'),
    dataIndex: 'name',
    render: (name) => name || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.client'),
    dataIndex: 'client',
    render: (client) => client || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.business_type'),
    render: (_, record) => record?.business_type?.name || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.device_types'),
    render: (_, record) => record?.device_types_name || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.slvdl'),
    dataIndex: 'slvId',
    render: (slvId) => slvId || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.gateway'),
    render: (_, record) => record?.gateway?.name || '-',
  },
];

const columnsDevices = (t, deleteDevice, currentUser, editDevice) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t);

  if (isAdmin) {

    columns.push(
      {
        key: 'has_missing_data_alarm_rule',
        width: '10%',
        title: '',
        dataIndex: 'id',
        render: (_, record) => ( // edit users
          // eslint-disable-next-line react/jsx-filename-extension
          <Space>
            <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
              <FontAwesomeIcon icon={faEdit} onClick={() => editDevice(record)} />
            </div>

            <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
              <Popconfirm
                title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
                okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
                cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
                onConfirm={() => deleteDevice(record)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Popconfirm>
            </div>
          </Space>
        ),
      },

    );

}

  return columns;

};

export default columnsDevices;
